export const ROW_ENTERED_CLASS = 'bomdisoft-row-entered';

export const ROW_ENTER_ANIMATION = 'bomdisoft-row-enter';

/**
 * How loud the arrival cue is, on three independent axes.
 *
 * A busy table wants a different cue from a quiet one: a live event feed that
 * appends every few seconds turns the default into noise, so it drops to one
 * weak, brisk pulse. A roles table that gains a row when someone creates one
 * keeps the default, where the whole point is that you notice.
 */
export type RowPulseOptions = {
  /** Rises and falls. Default 2. */
  pulseCount?: 1 | 2;
  /** Peak brand tint: weak 12%, normal 18%, strong 24%. Default normal. */
  pulseIntensity?: 'normal' | 'strong' | 'weak';
  /** One rise and fall: brisk 450ms, even 600ms, unhurried 800ms. Default even. */
  pulseSpeed?: 'brisk' | 'even' | 'unhurried';
};

/**
 * The attributes a table root carries so its rows take the chosen scale.
 *
 * Spread them on an ANCESTOR of the rows, never on a row itself: the stylesheet
 * matches each knob as `[data-pulse-…] .bomdisoft-row-entered`, a descendant
 * rule.
 *
 * Omitted rather than defaulted when a knob is unset, because the defaults live
 * in the stylesheet's `var()` fallbacks. Writing them here too would be a second
 * copy of the same three numbers, free to drift from the one that renders.
 */
export const rowPulseAttributes = ({ pulseCount, pulseIntensity, pulseSpeed }: RowPulseOptions = {}) => ({
  'data-pulse-count': pulseCount === undefined ? undefined : String(pulseCount),
  'data-pulse-intensity': pulseIntensity,
  'data-pulse-speed': pulseSpeed,
});
